<!-- Content -->
<div class="w-100 h-100" >
    <canvas baseChart *ngIf="chartConfig"
    [hidden]="this.firstLoad && !config.isCxOne"
    class="callArrivalGraph"
    width="400px"
    height="225px"
    [type]="chartConfig.type"
    [legend]="chartConfig.options.plugins.legend.display"
    [datasets]="chartConfig.data.datasets"
    [labels]="chartConfig.data.labels"
    [options]="chartConfig.options"
    [plugins]="chartConfig.plugins">
</canvas>
</div>
